export function videoPreview ($elements) {
	$elements.each((i, el) => {
		const $el = $(el);
		const $image = $el.find('[data-preview-image]');
		const $video = $el.find('[data-video]');
		const $playButton = $el.find('[data-play-button]');

		$playButton.on('click', function () {
			$(this).addClass('is-hidden');
			$image.addClass('is-hidden');
			$video.attr('src', $video.attr('src') + '?autoplay=1');
		});
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/video-preview.js